
import React, { useState, useEffect, useRef } from "react";
import { getAllDocument } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";


interface AppId{
  applicationId?:string,
  applicationType:string
}
const PdfLoaderModal: React.FC<AppId> = ({applicationId , applicationType}) => {
  const [files, setFiles] = useState<{ fileData: string; mimeType: string; fileName: string ;documentName:string}[]>([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalDocs, setTotalDocs] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const token = useSelector((state: any) => state.auth.token);
  // const userdetails = useSelector((state: any) => state.auth.userDetails);
const language = useSelector((state:any)=>state.auth.language);
  // Function to fetch one document per scroll
  const loadFile = async (pageNumber: number) => {
    if (loading || (files.length > 0 && files.length >= totalDocs)) return;

    setLoading(true);
    try {
      const response = await getAllDocument(applicationId, pageNumber, token , applicationType);
     

      if (response.success && response.doc.length > 0) {
        setFiles((prevFiles) => [...prevFiles, ...response.doc]); // Append new document
        setTotalDocs(response.totalDocs);
        setPage((prevPage) => prevPage + 1); // Increase page number for next scroll
      }
    } catch (error) {
      //.error("Error fetching file:", error);
    }
    setLoading(false);
  };

  // Function to handle modal open
  const handleModalOpen = () => {
    setFiles([]); // Reset previous files
    setPage(1);
    setTotalDocs(0);
    loadFile(1); // Load the first document
  };

  // Infinite Scroll - Fetch next document when scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      
      const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

      // Load next document when user scrolls near the bottom
      if  (scrollTop + clientHeight >= scrollHeight - 10 && !loading) {
        loadFile(page);
      }
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [page, loading, totalDocs]);

  // Listen for Bootstrap modal open event
  useEffect(() => {
    const modalElement = document.getElementById("pdf_loader_modal");
    if (modalElement) {
      modalElement.addEventListener("shown.bs.modal", handleModalOpen);
    }
    return () => {
      if (modalElement) {
        modalElement.removeEventListener("shown.bs.modal", handleModalOpen);
      }
    };
  }, []);

  const docOptions = [
    { value: "tarderPhoto", label: language.tra_ph},
    { value: "solvencyCertificate", label: language.solvencyCertificate },
    { value: "bankGuarntee", label: language.bankGuarntee },
    { value: "bankBalanceCertificate", label: language.bankBalanceCertificate },
    { value: "panCard", label: language.panCard},
    { value: "itReturns_1", label: language.itReturns_1 },
    { value: "itReturns_2", label: language.itReturns_2 },
    { value: "itReturns_3", label: language.itReturns_3 },
    { value: "electionCard", label: language.electionCard },
    { value: "chalanPayementLiceneseFeeDoc", label:"Challan in support of payment of license fees" },
    { value: "proofOfBusinessPalace", label: "Proof of Place of Business" },
    { value: "partnerShipDeed", label: "Partnership Deed" },
    { value: "companyArticleAssociation", label: "Article of Association" },
    { value: "companyAttorneyAuthorization", label: "Power of Attorney of Authorized Person" },
    { value: "coOpSocietyRegCertificate", label: "Co-operative Society Registration Certificate" },
    { value: "coOpSocietyByLaws", label: "Co-operative Society Bye-Laws" },
    { value: "coOpSocietyResObtLic", label: "Co-operative Society Resolution for Obtaining License" },
    { value: "coOpSocietyAuditReport", label: "Co-operative Society of Last Audit Report" },
    { value: "coOpSocietyIncomeExpenditure", label: "Co-operative Society Income-Expenditure Statement" },
    { value: "coOpSocietyBalanceSheetThreeYear", label: "Co-operative Society Balance Sheet for Last Three Years" },
    { value: "affidavit", label: "Proof of Probable Place Of Business and Market Committee" },
    { value: "enclousreDeclaration", label: "Enclosure Declaration" },
    { value: "declarations", label: "Declaration" },
    { value: "traderSignature", label: "Trader Signature" },
    { value: "otherDoc", label: "Additional other Document" },
    { value: "guarantorDeclaration", label: "Guarantor Declaration" },
    { value: "license", label: "License" },
    { value: "guarantorPanCard_2", label: "guarantor 2  pan card number " },
    { value: "guarantorPanCard_1", label: "guarantor 1  pan card number " },
    { value: "guarantorPhoto_2", label: "guarantor 2  photo" },
    { value: "guarantorPhoto_1", label: "guarantor 1  photo" },
    { value: "guarantorSignature_2", label: "guarantor 2  signature" },
    { value: "guarantorSignature_1", label: "guarantor 1  signature" },
    { value: "gstCertificateDocs", label: "GST Certificate" },
    { value: "panCardNo", label: "PAN Card No." },
    { value: "agentSignature", label: "Agent Signature" },
  ]
  

  return (
    <div className="modal fade" id="pdf_loader_modal" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{language.vdocs}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div
            className="modal-body"
            ref={containerRef}
            style={{ maxHeight: "500px", overflowY: "auto" }}
          >
            {files.length === 0 && !loading && <p>No documents found</p>}
            {files.map((file, index) => (
              <div key={index} className="mt-3">
                <p><strong>{language.fn} : {file.fileName} <h3>{language.dn} :{docOptions.find(doc => doc.value === file?.documentName)?.label || "N/A"}</h3></strong></p>
                {/* Image File */}
                {file.mimeType.startsWith("image/") && (
                  <img src={file.fileData} alt={file.fileName} style={{ width: "100%", maxHeight: "800px" }} />
                )}
                {/* PDF File */}
                {file.mimeType === "application/pdf" && (
                  <iframe src={file.fileData} width="100%" height="500px" title={`PDF Viewer ${index}`} />
                )}
                {/* Other File Types */}
                {!file.mimeType.startsWith("image/") && file.mimeType !== "application/pdf" && (
                  <a href={file.fileData} download={file.fileName} className="text-primary">
                    {language.down}{file.fileName}
                  </a>
                )}
              </div>
            ))}
            {loading && <p>Loading...</p>}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              {language.close}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfLoaderModal;

